import {
  post
} from "../API/cloudFunctions";
import firebase from "firebase";
import * as uuid from 'uuid/v4';
export default class Notification_ {

  constructor(obj) {
    //defaulte Values
    if (obj) {
      // fix uuid
      this.id = obj.id || uuid();
      this.type = (obj.type ? obj.type : 'Alert');
      this.message = (obj.message ? obj.message : ' Default message that can be changed ');
      this.Date = (obj.date ? obj.date : new Date());
      this.seen = false;
    } else {
      this.id =uuid();
      this.type = 'Alert'
      this.message = ' Default message that can be changed ';
      this.Date = new Date();
      this.seen = false;
    }

  }


}



// WEBPACK FOOTER //
// ./src/Class/Notification.js